define([
	"dojo/_base/declare",
	"csi/action/Controller",
	"csi/comm",
	"csi/resolver",
	"csi/session",
	"csi/xml"
], function(declare,Controller,comm,resolver,session,xml) {

	return declare(Controller, {
		_templateURL: null,

		getFormData: function() {
			// summary: prevent the editability of the Node Name field in the pop-up form
			// from tracking that of the TestRun Node Name
			var fd = this.inherited(arguments);
			fd.setNode(null);
			return fd;
		},

		toWriterRequest: function() {
			// summary: supply the URL for the new template to the server operation
			this._templateURL = comm.createUrl("TestRun");
			return this.inherited(arguments).addParameter("TemplateURL", xml.ATTR_CNL, this._templateURL);
		},

		postProcessSuccess: function() {
			// summary: navigate to new node
			resolver.resolveNode("centric://QUALITY/QualityAdmin", true);
			session.setLocationUrl(this._templateURL, true);
		}
	});
});